import React from "react";
import BankInfoHolder from "./bankInfoHolder";
import {useSelector} from "react-redux";
import BankInfoDetails from "./bankInfoDetails";

const BankDepositSection = () => {
    const bankInfo = useSelector(state => state.payoutBankInfo);

    return (
        <div className="p-2 ps-0 payoutsMethod">
            <span className="sub-title">Bank Information</span>
            {bankInfo === null && <BankInfoHolder/>}
            {bankInfo !== null && <BankInfoDetails/>}
        </div>
    )
}

export default BankDepositSection;